module.exports = __webpack_public_path__ + "static/media/carlisle-theater--resized.3af26618.jpg";